import { render } from "./UEInsuranceWorkerListView.vue?vue&type=template&id=60d52536&scoped=true"
import script from "./UEInsuranceWorkerListView.vue?vue&type=script&lang=js"
export * from "./UEInsuranceWorkerListView.vue?vue&type=script&lang=js"

import "./UEInsuranceWorkerListView.vue?vue&type=style&index=0&id=60d52536&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-60d52536"]])

export default __exports__